import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CryptoFilterState {
  showOnlyLoanEligible: boolean;
}

const initialState: CryptoFilterState = {
  showOnlyLoanEligible: localStorage.getItem("cryptoLoanFilter") 
    ? JSON.parse(localStorage.getItem("cryptoLoanFilter")!) 
    : false,
};

const cryptoFilterSlice = createSlice({
  name: "cryptoFilter",
  initialState,
  reducers: {
    toggleLoanFilter(state) {
      state.showOnlyLoanEligible = !state.showOnlyLoanEligible;
      localStorage.setItem("cryptoLoanFilter", JSON.stringify(state.showOnlyLoanEligible));
    },
    setLoanFilter(state, action: PayloadAction<boolean>) {
      state.showOnlyLoanEligible = action.payload;
      localStorage.setItem("cryptoLoanFilter", JSON.stringify(action.payload));
    },
  },
});

export const { toggleLoanFilter, setLoanFilter } = cryptoFilterSlice.actions;
export default cryptoFilterSlice.reducer;